/**
 * Module 133 (WP-133.4) — where the in-puzzle toasts (badge, mission) sit, in
 * their offset parent's px.
 *
 * Portrait: just under the status capsule, which is the HUD's top row there.
 * Landscape: the capsule is in the LEFT rail, halfway down, so "under the
 * capsule" at the right edge put the toast over the power-up grid (user,
 * 2026-11-03, the Colour Bomb covered). There it sits just under the Top Bar,
 * in the clear strip above the power-up rail.
 */
export function toastTop(el) {
    const parent = el.offsetParent;
    if (!parent)
        return null;
    const landscape = el.closest('[data-layout-mode="landscape"]') !== null ||
        document.documentElement.dataset.layout === 'landscape';
    const anchor = landscape
        ? document.querySelector('.game-layout__top-bar')
        : document.querySelector('[data-testid="bj-status"]');
    if (!anchor)
        return null;
    return anchor.getBoundingClientRect().bottom - parent.getBoundingClientRect().top + 8;
}
